import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loadingSubject = new BehaviorSubject<boolean>(false);
  updateLoader$: Observable<boolean> = this.loadingSubject.asObservable();

  constructor() {}

  showPreloader(): void {
    Promise.resolve().then(() => this.loadingSubject.next(true));
  }

  hidePreloader(): void {
    Promise.resolve().then(() => this.loadingSubject.next(false));
  }
}
